/**
 * A non-searchable plain text input for anchor IDs.
 * Reuses the title-editor template but is configured as non-searchable
 * in component_tools_config.yml to prevent anchor slugs from polluting
 * the search index.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    name: "anchor-editor",
    templateId: "title-editor-template",

    update: function (element, context) {
      this.updateInput();
    },

    bind: function (component) {
      this.listenToInput();
    },

    unbind: function (element) {
      this.disableInput("input");
    },
  });
})();
